import type { PreloadedState } from '@reduxjs/toolkit';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import authReducer from '../features/auth/authSlice';
import signupReducer from '../features/landing/signup/signupSlice';
import featureFlagReducer from '../features/featureFlag/featureFlagSlice';
import chatReducer from '../features/chat/chatSlice';
import inviteReducer from '../features/invite/inviteSlice';
import paymentsSliceReducer from '../features/payments/paymentsSlice';
import tokenInfoSliceReducer from '../features/tokenInfo/tokenInfoSlice';
import MerchantAuthReducer from '../features/merchant/merchantAuthSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  signup: signupReducer,
  featureFlag: featureFlagReducer,
  chat: chatReducer,
  invite: inviteReducer,
  payments: paymentsSliceReducer,
  tokenInfo: tokenInfoSliceReducer,
  merchantAuth: MerchantAuthReducer
});

export function setupStore(preloadedState?: PreloadedState<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: process.env.NODE_ENV === 'development',
  });
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;
